// extracted by mini-css-extract-plugin
module.exports = {"margin-top10px":"style_margin-top10px__2mObU","margin-bottom10px":"style_margin-bottom10px__1zH4Z","margin-bottom5px":"style_margin-bottom5px__2Wf_j"};